export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.aplace.test/' : 'https://api.aplace.com/';
// export const contentAPI = 'https://api.aplace.com/';

// export const checkoutAPI = process.env.NODE_ENV === 'development' ? 'https://aplace.centraqa.com/api/checkout' : 'https://aplace.centra.com/api/checkout';
export const checkoutAPI = 'https://aplace.centra.com/api/checkout';

export const depictAPI = 'https://api.depict.ai/v3/';

export const origin = 'https://www.aplace.com';

export const paymentMethodsMapping = {
	klarnaCheckout: 'klarna_checkout',
	stripeCheckout: 'stripe-checkout',
	stripePaymentIntents: 'stripe-payment-intents',
};

export const shippingMethods = {
	airmee: 'AIRMEE',
};

export const shippingMethodsOrder = ['schenker', 'AIRMEE', 'aplace-stockholm', 'aplace-goteborg', 'aplace-malmo'];

export const urlRoots = [
	'aplace',
];
